@if (tipsVises()) {
  <ropert (vedSkjul)="skjulTips()" blokk="true" data-testid="aktiver-presentasjonsmodus-tips">
    <span (click)="aktiverPresentasjonsmodusOgSkjuleTips()" class="melding">
      <mat-icon fontSet="ion-ios-monitor-outline" class="mat-icon--ionic-ikon" inline="true"/>
      <a>{{ 'Aktiver presentasjonsmodus'|translate }}</a>
    </span>
  </ropert>
}
